export default "__VITE_ASSET__1cbe92a9__"